<template
  ><v-form ref="form" v-model="formValid" lazy-validation>
    <v-card class="v-card-movable">
      <v-card-title
        class="d-flex justify-space-between align-center px-4 py-2 mb-3"
        >{{ formTitle }}
        <Button large rounded icon @click="close(false)" color="error"
          ><v-icon>mdi-close</v-icon></Button
        ></v-card-title
      >
      <v-container class="pa-4 pt-0"
        ><v-row dense
          ><v-col cols="12" class="py-0">
            <Select
              label="Sortiment"
              v-model="assortment.assortmentRegistryId"
              :items="assortmentsRegistry"
              :item-text="e => `${e.identificator} (${e.name})`"
              item-value="id"
              jePovinne
              hledani
              :zvolitPrvni="false"
              :povolenaEditace="formMode != formModes.read"
          /></v-col>
          <v-col cols="12" class="py-0"
            ><InputNumber
              label="Množštví"
              :max="1000000"
              v-model="assortment.amount"
              jePovinne
              :povolenaEditace="formMode != formModes.read"
          /></v-col>
          <v-col cols="12" class="py-0"
            ><InputNumber
              label="Vlastní výkupní cena MJ"
              :max="1000000"
              v-model="assortment.customBuyingPrice"
              :povolenaEditace="formMode != formModes.read"
          /></v-col>
          <v-col cols="12" class="py-0">
            <v-row>
              <v-col md="4" cols="6"
                ><Button
                  small
                  fillWidth
                  :povolenaEditace="formMode != formModes.read"
                  @click="setCustomBuyingPrice(1)"
                  >Cena standard</Button
                ></v-col
              >
              <v-col md="4" cols="6"
                ><Button
                  small
                  fillWidth
                  :povolenaEditace="formMode != formModes.read"
                  @click="setCustomBuyingPrice(2)"
                  >Cena VIP</Button
                ></v-col
              >
              <v-col md="4" cols="12"
                ><Button
                  fillWidth
                  small
                  :povolenaEditace="formMode != formModes.read"
                  @click="setCustomBuyingPrice(3)"
                  >Plná cena</Button
                ></v-col
              >
            </v-row>
          </v-col>
          <v-col cols="12" class="py-0"
            ><InputNumber
              label="Vlastní prodejní cena MJ"
              :max="1000000"
              v-model="assortment.customSellingPrice"
              :povolenaEditace="formMode != formModes.read"
          /></v-col> </v-row
      ></v-container>
      <v-card-actions class="d-flex justify-center"
        ><Button
          color="primary"
          @click="save"
          :povolenaEditace="formValid"
          v-if="formMode != formModes.read"
          >Uložit</Button
        >
        <Button
          color="primary"
          @click="formMode = formModes.edit"
          v-if="formMode == formModes.read"
          >Povolit editaci</Button
        >
        <Button @click="close(false)">Zavřít</Button></v-card-actions
      ></v-card
    ></v-form
  >
</template>

<script>
export default {
  data() {
    return {
      formValid: true,
      formMode: null,
      original: null,
      assortment: {}
    };
  },
  props: {
    formModeProp: {
      type: String,
      default: null
    },
    assortmentProp: {
      type: Object,
      default: null
    },
    date: {
      type: String,
      default: null
    }
  },
  async created() {
    this.formMode = this.formModeProp;
    this.original = this.$_.cloneDeep(this.assortmentProp);
    this.assortment = this.assortmentProp;

    await this.getAssortmentsRegistry({ date: this.date });
    await this.verifySuccessCall();
  },
  computed: {
    ...window.get(['formModes', 'assortmentRegistry/assortmentsRegistry']),
    formTitle() {
      return `Sortiment - ${this.formMode}`;
    }
  },
  methods: {
    ...window.call(['assortmentRegistry/getAssortmentsRegistry']),
    async close(confirmed) {
      if (!confirmed && this.isDifferent(this.assortment, this.original)) {
        if (!(await this.confirmClose())) {
          return;
        }
      }

      const assortmentRegistry = this.assortmentsRegistry.find(
        el => el.id == this.assortment.assortmentRegistryId
      );

      this.assortment.amount = parseFloat(this.assortment.amount);
      this.$emit('submit', {
        confirmed,
        newAssortment: {
          ...this.assortment,
          assortmentRegistry: assortmentRegistry,
          totalPrice:
            this.assortment?.amount *
            (this.assortment?.customSellingPrice ??
              assortmentRegistry?.unitSellingPrice)
        }
      });
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.showFormNotValid();
        return;
      }
      await this.close(true);
    },
    setCustomBuyingPrice(type) {
      // type == 1 standard
      // type == 2 VIP
      // type == 3 full price (as selling)

      const assortmentRegistry = this.assortmentsRegistry.find(
        el => el.id == this.assortment.assortmentRegistryId
      );

      let newPrice = assortmentRegistry.unitSellingPrice;

      if (type === 1) {
        newPrice = assortmentRegistry.unitSellingPrice - 200;
      } else if (type === 2) {
        newPrice = assortmentRegistry.unitSellingPrice - 100;
      }
      this.$set(this.assortment, 'customBuyingPrice', newPrice);
    }
  }
};
</script>

<style></style>
